import { Users, Shield, Star } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const TRUST_ITEMS: ReadonlyArray<{ icon: LucideIcon; label: string }> = [
  { icon: Users, label: 'Progettato con psicologi' },
  { icon: Shield, label: 'GDPR senza scorciatoie' },
  { icon: Star, label: 'Zero diagnosi automatiche' },
];
